const MAX_REASON_CHARS = 300;

export function failureReason(errorMessage: string | null): string | null {
  if (errorMessage === null) return null;
  const lines = errorMessage
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line !== '');
  const last = lines.at(-1);
  if (last === undefined) return null;
  return last.length > MAX_REASON_CHARS ? `${last.slice(0, MAX_REASON_CHARS)}…` : last;
}
